import React from "react";

const Brands = () => {
  return (
    <div className="brands container">
      <h1 className="h1">Brands</h1>
    </div>
  );
};

export default Brands;
